'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Utils


// Actions


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _stringUtil = require('../../../../../common/utils/stringUtil');

var _timeUtil = require('../../../../../common/utils/timeUtil');

var _notificationActions = require('../../../../notifications/notificationActions');

var _currentUserActions = require('../../../../user/currentUserActions');

var _Button = require('../../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _PopupPanel = require('../../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _ModifiedBoardMessage = require('./modifiedBoard/ModifiedBoardMessage');

var _ModifiedBoardMessage2 = _interopRequireDefault(_ModifiedBoardMessage);

var _PopupList = require('../../../../components/popupPanel/types/PopupList');

var _PopupList2 = _interopRequireDefault(_PopupList);

var _PopupEmptyContent = require('../../../../components/popupPanel/PopupEmptyContent');

var _PopupEmptyContent2 = _interopRequireDefault(_PopupEmptyContent);

var _PopupUserErrorEmptyContent = require('../common/PopupUserErrorEmptyContent');

var _PopupUserErrorEmptyContent2 = _interopRequireDefault(_PopupUserErrorEmptyContent);

var _notificationUtilSelector = require('./notificationUtilSelector');

var _notificationUtilSelector2 = _interopRequireDefault(_notificationUtilSelector);

require('./NotificationPopup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchMarkBoardsAsSeen: function dispatchMarkBoardsAsSeen(boardIds, userId) {
            return dispatch((0, _notificationActions.markBoardsAsSeen)({ ids: boardIds, userId: userId }));
        },
        updateLastCheckedTime: function updateLastCheckedTime(currentUserId) {
            return function () {
                dispatch((0, _currentUserActions.updateCurrentUser)({
                    userId: currentUserId,
                    changes: {
                        lastCheckedNotifications: (0, _timeUtil.getTimestamp)()
                    }
                }));
            };
        }
    };
};

var notificationPopupHandlers = {
    clearNotifications: function clearNotifications(_ref) {
        var dispatchMarkBoardsAsSeen = _ref.dispatchMarkBoardsAsSeen,
            currentUser = _ref.currentUser,
            notifications = _ref.notifications;
        return function (event) {
            var boardIds = notifications.map(function (notification) {
                return notification.get('id');
            }).toArray();
            dispatchMarkBoardsAsSeen(boardIds, currentUser.get('_id'));
        };
    }
};

var NotificationPopupEmptyContent = function NotificationPopupEmptyContent(props) {
    return _react2.default.createElement(
        'ul',
        null,
        _react2.default.createElement(
            'li',
            { key: 'empty' },
            _react2.default.createElement(_PopupEmptyContent2.default, { message: 'You\'re all up to date.' })
        )
    );
};

var NotificationList = function NotificationList(_ref2) {
    var notifications = _ref2.notifications,
        activeNotifications = _ref2.activeNotifications,
        clearNotifications = _ref2.clearNotifications;

    var title = activeNotifications.size ? activeNotifications.size + ' unseen ' + (0, _stringUtil.pluralise)('update', activeNotifications.size) : 'No changes since your last visit';

    var actions = _react2.default.createElement(
        _Button2.default,
        { className: 'clear-button', onClickFn: clearNotifications },
        'Mark all as seen'
    );

    return _react2.default.createElement(
        _PopupList2.default,
        { title: title, actions: actions, list: notifications },
        function (notification, index) {
            return _react2.default.createElement(_ModifiedBoardMessage2.default, {
                notification: notification,
                active: activeNotifications.contains(notification.get('id')) });
        }
    );
};

var NotificationPopup = function NotificationPopup(props) {
    var notifications = props.notifications,
        updateLastCheckedTime = props.updateLastCheckedTime,
        currentUser = props.currentUser,
        errorUserIds = props.errorUserIds,
        notificationsReady = props.notificationsReady;


    var content = null;
    if (errorUserIds.length) {
        content = _react2.default.createElement(_PopupUserErrorEmptyContent2.default, _extends({ userIds: errorUserIds }, props));
    } else if (notificationsReady) {
        content = notifications.size ? _react2.default.createElement(NotificationList, props) : _react2.default.createElement(NotificationPopupEmptyContent, props);
    } else {
        content = _react2.default.createElement(_PopupEmptyContent2.default, { showSpinner: true });
    }

    return _react2.default.createElement(
        _PopupPanel2.default,
        _extends({}, props, {
            popupId: 'notification',
            className: (0, _classnames2.default)('NotificationPopup', { new: notifications.size }),
            onClose: updateLastCheckedTime(currentUser.get('_id')) }),
        content
    );
};

NotificationList.propTypes = NotificationPopup.propTypes = {
    notifications: _propTypes2.default.object,
    activeNotifications: _propTypes2.default.object,
    currentUser: _propTypes2.default.object,
    updateLastCheckedTime: _propTypes2.default.func,
    errorUserIds: _propTypes2.default.array,
    notificationsReady: _propTypes2.default.bool
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(_notificationUtilSelector2.default, mapDispatchToProps), (0, _recompose.withHandlers)(notificationPopupHandlers));

exports.default = enhance(NotificationPopup);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/notifications/NotificationPopup.js
// module id = 781
// module chunks = 0